import React from 'react';
import { MediaItem } from '../../lib/types';
import { formatCurrency } from '../../lib/export';

interface MediaTableProps {
  data: MediaItem[];
  className?: string;
}

export function MediaTable({ data, className = '' }: MediaTableProps) {
  const formatDateTime = (dateTime: string) => {
    return new Date(dateTime).toLocaleString();
  };

  const formatPlayoutTime = (seconds: number) => {
    const minutes = Math.floor(seconds / 60);
    const remainingSeconds = seconds % 60;
    return `${minutes}:${remainingSeconds.toString().padStart(2, '0')}`;
  };

  const formatImpact = (impact: number) => {
    return formatCurrency(impact);
  };

  return (
    <div className={`bg-white p-6 rounded-lg shadow ${className}`}>
      <h3 className="text-lg font-semibold text-gray-900 mb-4">Media Performance</h3>
      
      <div className="overflow-x-auto">
        <table className="min-w-full">
          <thead>
            <tr className="border-b border-gray-200">
              <th className="text-left py-3 px-4 font-medium text-gray-900">Media Name</th>
              <th className="text-left py-3 px-4 font-medium text-gray-900">Media Owner</th>
              <th className="text-left py-3 px-4 font-medium text-gray-900">Start Date/Time</th>
              <th className="text-left py-3 px-4 font-medium text-gray-900">End Date/Time</th>
              <th className="text-right py-3 px-4 font-medium text-gray-900">Playout Time</th>
              <th className="text-right py-3 px-4 font-medium text-gray-900">Impact</th>
            </tr>
          </thead>
          <tbody>
            {data.map((media) => (
              <tr key={media.mediaId} className="border-b border-gray-100 hover:bg-gray-50">
                <td className="py-3 px-4 text-sm font-medium text-gray-900">{media.mediaName}</td>
                <td className="py-3 px-4 text-sm text-gray-600">{media.mediaOwner}</td>
                <td className="py-3 px-4 text-sm text-gray-600">{formatDateTime(media.startDateTime)}</td>
                <td className="py-3 px-4 text-sm text-gray-600">{formatDateTime(media.endDateTime)}</td>
                <td className="py-3 px-4 text-sm text-right text-gray-900">{formatPlayoutTime(media.playoutTime)}</td>
                <td className="py-3 px-4 text-sm text-right font-medium text-green-600">
                  {formatImpact(media.impact)}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
